<template>
  <div>
    <DataTable
      :value="supportCases"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedSupportCases"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} SupportCases"
    >
      <template #empty> No SupportCases found. </template>
      <template #loading> Loading SupportCases data. Please wait. </template>
      <Column
        field="caseNo"
        header="Case #"
        headerStyle="width: 4em"
        :sortable="true"
      />
      <Column
        field="type"
        header="Type"
        headerStyle="width: 8em"
        :sortable="true"
      />
      <Column
        field="description"
        header="Description"
        headerStyle="width: 8em"
        :sortable="true"
      />
      <Column
        field="dateAdded"
        header="Date & Time"
        headerStyle="width: 7em"
        :sortable="true"
      />
      <Column
        field="status"
        header="Status"
        headerStyle="width: 5em"
        :sortable="true"
      />
      <Column headerStyle="width: 9rem;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <Button
              label="View"
              icon="pi pi-info"
              @click="viewSupportCase(slotProps.data)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
export default {
  props: [
    'supportCases',
    'loading'
  ],
  data: () => ({
    selectedSupportCases: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    // W7 T7: this table was a copy of the Roles one and kept its actions. View Permissions and
    // Delete went on 2026-09-20; Edit went on 2026-09-27 (Mohammed) - it emitted
    // `edit-support-case`, which nothing listens for. View is the only action left.
    // Absolute, and in the case the route is registered under: the relative "SupportCases/..."
    // this replaces resolved to a path that exists nowhere.
    viewSupportCase(supportCase) {
      if (supportCase && supportCase.id)
        this.$router.push({
          path: "/supportCases/" + supportCase.id + "/detail",
          params: { caseid: supportCase.id },
        });
    }
  }
}
</script>

<style>

</style>